import React from 'react';
import { SearchOutlined } from '@mui/icons-material';
import './PageSearchBar.scss';

const PageSearchBar = (props) => {
  const {
    value,
    onChange,
    placeholder = 'Search',
    className,
    disabled = false,
    'aria-label': ariaLabel,
    ...other
  } = props;

  return (
    <div
      className={className ? `page-search-bar ${className}` : 'page-search-bar'}
      role="search"
    >
      <SearchOutlined aria-hidden />
      <input
        type="search"
        value={value ?? ''}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        aria-label={ariaLabel ?? placeholder}
        {...other}
      />
    </div>
  );
};

export default PageSearchBar;
